import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function LegalModal({
  isOpen,
  onClose,
  title,
  children
}: LegalModalProps) {
  return <AnimatePresence data-id="element-161">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/60 backdrop-blur-sm z-[100]" data-id="element-162" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} className="fixed inset-4 md:inset-auto md:left-1/2 md:top-1/2 md:-translate-x-1/2 md:-translate-y-1/2 md:w-full md:max-w-3xl md:max-h-[85vh] bg-white rounded-2xl shadow-2xl z-[101] overflow-hidden flex flex-col" data-id="element-163">
            {/* Header */}
            <div className="flex items-center justify-between p-6 border-b border-gray-200 flex-shrink-0" data-id="element-164">
              <h2 className="text-2xl font-serif font-bold text-[#2d2d2d]" data-id="element-165">
                {title}
              </h2>
              <button onClick={onClose} className="w-10 h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors text-gray-500 hover:text-gray-700" data-id="element-166">
                <X className="w-6 h-6" data-id="element-167" />
              </button>
            </div>

            {/* Content */}
            <div className="flex-1 overflow-y-auto p-6" data-id="element-168">{children}</div>

            {/* Footer */}
            <div className="flex-shrink-0 p-6 border-t border-gray-200 bg-gray-50" data-id="element-169">
              <button onClick={onClose} className="w-full bg-[#9d4b6b] hover:bg-[#8b6f6f] text-white font-medium py-3 px-6 rounded-full transition-colors" data-id="element-170">
                Cerrar
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}